<template>
  <div>
    <VCard title="RCA Analysis 🙌">
      <VCardText>Coming Soon</VCardText>
    </VCard>
  </div>
</template>

<script setup>
definePage({
  meta: {
    name: 'rca-dashboard',
  },  
})
</script>
